import type { IncidenceQueryData } from 'modules/bookkeepers/hooks/useGetIncidences'

export const MESSAGE_SENDER: Record<string, string> = {
  bookkeeper: 'bookkeeper',
  admin: 'admin',
}

const incidenceHasMessage = (isBookkeeper: boolean, incidence?: IncidenceQueryData | null) => {
  return (
    (incidence?.hasMessage &&
      (isBookkeeper
        ? incidence.messageFrom === MESSAGE_SENDER.admin
        : incidence.messageFrom === MESSAGE_SENDER.bookkeeper)) ??
    false
  )
}

export default incidenceHasMessage
